import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  LawPersonAddress,
} from '@gk/gk-modules';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
  ZamowienieGeomDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import { DateHelperUtil } from '../../../../utils/date-helper/date-helper.util';

export interface ALUNewRequestDto extends ExtendedApplicantRequestDto {
  CelWylaczenia: number;
  TerminRozpoczeciaInwestycji: string;
  WartoscGruntu?: number;
}

export class ALUNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    proxyDetailsArray: InvestorDetails[],
    public idNumber: number,
    public phoneNumber: number,
    public email: string,
    public address: LawPersonAddress,
    proxyDetailsCheckbox: boolean,
    public exclusionPurpose: number,
    public investmentCommencementDate: NgbDateStruct,
    public attachments: ApiNewDokumentPowiazanyDalDto,
    documentationForm: DocumentationFormType,
    public exclusionArea: ZamowienieGeomDto,
    shippingForm: Shipping,
    public landValue: number,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }
  static fromAppToApi(
    data: ALUNewRequest,
    parcels: EgibObject[],
    issueRanges: string[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): ALUNewRequestDto {
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        parcels,
        issueRanges,
        files,
      }),
      CelWylaczenia: data.exclusionPurpose,
      TerminRozpoczeciaInwestycji: data.investmentCommencementDate
        ? DateHelperUtil.ngbDateToApiDateTime(data.investmentCommencementDate)
        : undefined,
      WartoscGruntu: data.landValue,
    };
  }
}

export interface ALUNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: ALUNewRequest;
  parcels: EgibObject[];
  issueRanges: string[];
}
